import { adminPages, adminSections } from '../../variables/adminPages';
import { carbonPages, carbonSections } from '../../variables/carbonPages';
import { energyPages, energySections } from '../../variables/energyPages';
import { settingsPages, settingsSections } from '../../variables/settingsPages';
import { CHANGE_HEADER, INIT_HEADER } from '../actionsList';

const initialSettings = {
    object: {},
    header: 'dashboard',
    title: '',
};

const headersReducer = (state = initialSettings, action) => {
    switch (action.type) {
        case CHANGE_HEADER: {
            let list = action.options.list
            let count = action.options.count
            return {
                ...state,
                list: list,
                count: count,
            }
        }
        case INIT_HEADER: {
            let object = {}
            let header = ''
            let title = ''
            if (action.options != '') {
                switch (action.options) {
                    case 'document':
                        object.child = Object.values(adminPages)
                        object.section = Object.values(adminSections)
                        header = 'document'
                        title = '{{lang}}Documents Records'
                        break;
                    case 'energy':
                        object.child = Object.values(energyPages)
                        object.section = Object.values(energySections)
                        //Object.values(energySections)
                        header = 'energy'
                        title = '{{lang}}Energy'

                        break;

                    case 'carbon':
                        object.child = Object.values(carbonPages)
                        object.section = Object.values(carbonSections)
                        header = 'carbon'
                        title = '{{lang}}Carbon'

                        break;
                    case 'settings':
                        object.child = Object.values(settingsPages)
                        object.section = Object.values(settingsSections)
                        header = 'settings'
                        title = '{{lang}}Settings'
                        break;
                    }
                } else {
                    header = 'dashboard'
                    title = '{{lang}}Dashboard'
            }
            return {
                ...state,
                object: object,
                header,
                title
            }
        }

        default:
            return state;
    }
}

export default headersReducer;